var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg1M = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.652 6.036q.306 0 .595-.051.29-.05.519-.17.237-.12.4-.306a.9.9 0 0 0 .22-.459h.79V11H4.115V6.801H2.652zm4.222-1.105H8.37l1.674 4.752h.017l1.632-4.752h1.48V11H12.16V6.317h-.017L10.46 11h-.876L7.902 6.317h-.017V11H6.874z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(Svg1M);
export default ForwardRef;